<template>
  <basic-container>
    <el-form
      :inline="true"
      :model="form"
      label-position="right"
      :label-width="formLabelWidth"
    >
    <el-form-item label="手机号：">
        <el-input v-model="form.mobile" placeholder="手机号"></el-input>
      </el-form-item>
      <el-form-item label="用户ID：">
        <el-input v-model="form.userid" placeholder="uuid"></el-input>
      </el-form-item>

      <el-form-item label="uid：">
        <el-input style="width:200px;" v-model="form.uid" placeholder="uid"></el-input>
      </el-form-item>

      <el-form-item label="房间号：">
        <el-input v-model="form.code" placeholder="房间号"></el-input>
      </el-form-item>

   

      <el-form-item label="投屏码：">
        <el-input v-model="form.castCode" placeholder="投屏码"></el-input>
      </el-form-item>
      <el-form-item label="渠道：">
        <!-- <el-select v-model="form.appid" placeholder="全部" clearable filterable>
          <el-option
            v-for="item in channelList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select> -->
        <DynamicOption style="width:200px;" v-model="form.appid"  />
      </el-form-item>
      <el-form-item label="云桌面：">
        <el-select v-model="form.cloudType" placeholder="全部">
          <el-option label="不使用云桌面" value="0"></el-option>
          <el-option label="威尔云桌面" value="1"></el-option>
          <el-option label="阿里云桌面" value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="时长：">
        <el-input-number v-model="form.timeMinutes" placeholder="请输入分钟数" :min="0" :max="99999" :controls="false"></el-input-number>
      </el-form-item>


      <el-form-item label="状态：">
        <el-select v-model="form.status" placeholder="全部">
          <el-option label="进行中" value="1"></el-option>
          <el-option label="已结束" value="0"></el-option>
        </el-select>
      </el-form-item>


      

      <el-form-item label="创建日期：">
        <el-date-picker
          v-model="form.startEndDate"
          type="daterange"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
        <el-button icon="el-icon-delete" @click="onSubmitClear"  class="_delete_btn">清空</el-button>

      </el-form-item>

      

      <el-form-item label=" "  class="_onSubmit_btn" >
        <el-button icon="el-icon-search" type="primary" @click="onSubmit" v-auth="'RABBIT_METTING-MANAGE_SEARCH'" >
          搜索
        </el-button>

      </el-form-item>
  
    </el-form>
    <div class="table_header">
      <div>会议列表</div>
      <div class="table_header_stop"  v-auth="'RABBIT_METTING-MANAGE_END'">
        <span @click="stopAll">批量终止</span>
      </div>
    </div>
    <el-table
      @selection-change="handleSelectionChange"
      :data="tableData"
      border
      style="width: 100%"
      v-loading="loading"
    >
      <el-table-column type="selection" width="55"> </el-table-column>
      <el-table-column prop="code" label="房间号" width="180">
        <template slot-scope="scope">
          <span style="color: #1d28e2"> {{ scope.row.code }}</span>
        </template>
      </el-table-column>

      <el-table-column prop="status" label="状态">
        <template slot-scope="scope">
          <span style="color: #209763" v-if="scope.row.status === 1">
            进行中
          </span>
          <span style="color: #db0d0d" v-else> 已结束 </span>
        </template>
      </el-table-column>
      <el-table-column prop="createTime" label="开始时间"> </el-table-column>
      <el-table-column prop="duration" label="会议时长（时-分-秒）">
      </el-table-column>
      <el-table-column prop="address" label="操作">
        <template slot-scope="scope">
          <el-button
            v-if="permission.metting_detail"
            type="text"
            size="small"
            @click="goHref(scope.row)"
          >
            详情
          </el-button>

          <el-button
            v-if="scope.row.status === 1"
            @click="saveID(scope.row)"
            type="text"
            size="small"
            v-auth="'RABBIT_METTING-MANAGE_END'"
          >
            终止
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="pagination"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="params.current"
      :page-sizes="[10, 20, 40, 50, 100]"
      :page-size="params.size"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
    >
    </el-pagination>
    <!--  删除-->
    <el-dialog
      :title="stopTitle"
      :visible.sync="deleteStrategy"
      width="30%"
      :modal-append-to-body="false"
    >
      <div class="dialog-text">
        远程终止会议将导致会议<span class="red_text">立即结束</span>
        ，会议所有人离开房间，云桌面资源释放，<span class="red_text"
          >且无法再次开启</span
        >
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="deleteStrategy = false">取 消</el-button>
        <el-button :loading="loadingSure" type="primary" @click="dialogSure"
          >确 认</el-button
        >
      </div>
    </el-dialog>
  </basic-container>
</template>
<script>
import {
  getList,
  stopData,
  getChannelsResource,
} from "@/api/rabbit/metting-manage";
import { mapGetters } from "vuex";
import DynamicOption from '@/components/DynamicOption/index.vue'
export default {
  components:{DynamicOption},
  name:"metting-manage",
  data() {
    return {
      channelList: [],
      loading: false,
      loadingSure: false,
      total: 0,
      deleteStrategy: false,
      params: {
        size: 10,
        current: 1,
      },
      form: {
        startEndDate: "",
        createDateEnd: "",
        createDateBegin: "",
      },
      formLabelWidth: "150px",
      tableData: [],
      selectionIds: [],
    };
  },
  methods: {
    goHref(row) {
      this.$router.push({
        path: `/rabbit/metting-detail?id=${row.id}`,
      });
    },
    handleSizeChange(val) {
      this.params.size = val;
      this.getDataList();
    },
    handleCurrentChange(val) {
      this.params.current = val;
      this.getDataList();
    },
    onSubmit() {
      const { startEndDate, ...data } = this.form;
      this.params.current = 1;
      if (startEndDate) {
        const createDateBegin = new Date(startEndDate[0])
          .toLocaleString()
          .replace(/\//g, "-");
        const createDateEnd = new Date(startEndDate[1])
          .toLocaleString()
          .replace(/\//g, "-");
        this.form = {
          ...this.form,
          createDateBegin,
          createDateEnd,
        };
        this.getDataList({
          ...this.params,
          ...data,
          createDateBegin,
          createDateEnd,
        });
      } else {
        this.getDataList({ ...this.params, ...data });
      }
    },
    getChannelsData() {
      getChannelsResource().then((res) => {
        this.channelList = res.data.data || [];
      });
    },
    onSubmitClear() {
      this.params.current = 1;
      this.form = {
        keyword: "",
        status: "",
        createDateEnd: "",
        createDateBegin: "",
      };
      this.getDataList();
    },
    getDataList() {
      this.loading = true;
      const { startEndDate, ...data } = this.form;
      const _data = { ...this.params, ...data };
      if(Array.isArray(_data.appid)){
        _data.appid = _data.appid.join()
      }
      getList(_data)
        .then((res) => {
          const data = res.data.data;
          this.total = data.total;
          this.tableData = data.records;
          this.startEndDate = startEndDate;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleSelectionChange(val) {
      const list = [];
      val.forEach((item) => {
        list.push(item.id);
      });
      this.selectionIds = list;
    },
    stopAll() {
      this.deleteStrategy = true;
      this.stopTitle = "批量终止确认";
    },
    // 点击终止
    saveID(row) {
      this.deleteStrategy = true;
      this.selectionIds = [row.id];
      this.stopTitle = "会议终止确认";
    },
    dialogSure() {
      this.loadingSure = true;
      stopData(this.selectionIds.join(","))
        .then(() => {
          this.getDataList();
        })
        .finally(() => {
          this.deleteStrategy = false;
          this.selectionIds = [];
          this.loadingSure = false;
        });
    },
  },
  computed: {
    ...mapGetters(["permission"]),
  },
  mounted() {
    this.getDataList();
  },
};
</script>
<style  lang="scss" scoped>
.pagination {
  text-align: right;
  padding: 20px;
}

.el-input {
  width: auto;
}

.dialog-text {
  text-align: center !important;
}

.el-dialog__footer,
.dialog-footer {
  text-align: center;
}

.top {
  color: rgba(16, 16, 16, 100);
  font-size: 14px;
  text-align: left;
  font-family: SourceHanSansSC-regular;

  .top_name {
    margin-right: 80px;
  }
}

.content {
  font-family: SourceHanSansSC-regular;
  h4 {
    color: rgba(16, 16, 16, 100);
    font-size: 18px;
    text-align: left;
    position: relative;
    padding-left: 10px;
    &::before {
      content: "";
      position: absolute;
      left: 0;
      width: 3px;
      height: 15px;
      background: #3c7ee5;
      top: 5px;
    }
  }

  .content_c {
    padding: 16px 16px;
    background-color: rgba(249, 247, 247, 100);
    .appoint {
      color: #bd3124;
      font-size: 14px;
      text-align: left;
      margin: 30px 0 0 0;
    }

    .addFirm {
      color: #3c7ee5;
      font-size: 14px;
      margin-left: 25px;
      cursor: pointer;
    }

    .deleteFirm {
      color: #db0d0d;
      font-size: 24px;
      margin-left: 40px;
    }
  }

  .el-form--label-top .el-form-item__label {
    padding: 0;
  }
}

.table_header {
  height: 42px;
  width: 100%;
  color: #333333;
  background: #eeeded;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
  padding: 0 18px;
  font-size: 14px;
  font-family: SourceHanSansSC-regular;

  .table_header_stop {
    color: #1454f4;
    cursor: pointer;
  }
}
.red_text {
  color: #db0d0d;
}

  ::v-deep.el-input-number .el-input__inner {
    text-align: left !important;
  }
._delete_btn{
  margin-left: 15px;
}
._onSubmit_btn{
  width: calc(100% - 700px);
  max-width: 500px;
  text-align: right;
}
</style>